exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 576px) {\n.signContents[data-v-29205ba6] {\n        width: 530px;\n}\n}\n.signUpForm[data-v-29205ba6] {\n    height: 100vh;\n}\n", ""]);

// exports
